import { useEffect } from 'react'
import { contextSessionRealtimeService } from '../../../services/contextSessionRealtimeService'
import agentService from '../../../services/agentService'

export function useRealtimeStages(sessionId, { onStage, onRefresh }) {
  useEffect(() => {
    if (!sessionId) return undefined
    const unsubscribe = contextSessionRealtimeService.subscribe(
      sessionId,
      {
        onEvent: async (event) => {
          onStage?.(event)
          await onRefresh?.(sessionId)
        },
      },
      { anonymousToken: agentService.getStoredToken(sessionId) }
    )
    return unsubscribe
  }, [sessionId, onStage, onRefresh])
}
